import './search-empty-results.style.scss';

export { default } from './search-empty-results';
